
import axios from '@/assets/http';

export default {
    get(params) {
        return axios.post(`/api/house/filter`, params);
    },
    getInfo(params) {
        return axios.get(`/api/house/getHouseInfo`, { params: params,
            headers: {'map-company':'baidu'}
        });
    },
    filterType(params) {
        return axios.get(`/api/house/filterType`, { params: params });
    },
    
}
